import { observer } from 'mobx-react-lite'
import { useLocation, useParams } from 'react-router-dom'
import { AdministratorUserDetailsPage, InitialUserMeta } from './AdministratorUserDetailsPage'

type UserDetailsLocationState = {
  initialUserMeta?: Partial<InitialUserMeta>
}

export const UserDetailsNotFoundPage = observer(() => {
  const { userId } = useParams()
  const location = useLocation()
  const routeUserMeta = (location.state as UserDetailsLocationState | null)?.initialUserMeta

  if (!userId) {
    throw new Error('Missing user key')
  }

  const initialUserMeta: InitialUserMeta = {
    userId: routeUserMeta?.userId ?? userId,
    name: routeUserMeta?.name ?? '',
    email: routeUserMeta?.email ?? '',
    avatarUrl: routeUserMeta?.avatarUrl ?? '',
    memberSince: routeUserMeta?.memberSince ?? '',
  }

  return (
    <AdministratorUserDetailsPage initialUserMeta={initialUserMeta} />
  )
})
